import { Box, Input, Text, FormLabel, Button } from "@chakra-ui/react";

import { useFormik } from "formik";
import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";

const LoginForm = ({ login }) => {
  const toast = useToast();

  const [loading, setLoading] = useState(false);

  const validate = (values) => {
    let errors = {};
    if (!values.email) {
      errors.email = "Email Address is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    if (!values.password) {
      errors.password = "Password is required";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      setLoading(true);

      let data = {
        email: values.email,
        password: values.password,
      };

      login(data)
        .then((res) => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.data.status === false) {
            // not authorized!
            return toast({
              title: "Error",
              description: "Email address or password is incorrect",
              status: "error",
              duration: 9000,
              isClosable: true,
            });
          }
          // some error occurred
          return toast({
            title: "Error",
            description: "Something went wrong, please try again",
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        });
    },
  });

  return (
    <>
      <Box as="form" px={8} onSubmit={formik.handleSubmit}>
        <Box>
          <FormLabel htmlFor="email">Email Address</FormLabel>
          <Input
            id="email"
            type="email"
            name="email"
            onChange={formik.handleChange}
            value={formik.values.email}
          />

          {formik.errors.email ? (
            <Text color="red.500" fontSize="sm" mt={3}>
              {formik.errors.email}
            </Text>
          ) : null}
        </Box>

        <Box mt={4}>
          <FormLabel htmlFor="password">Password</FormLabel>
          <Input
            id="password"
            type="password"
            name="password"
            onChange={formik.handleChange}
            value={formik.values.password}
          />

          {formik.errors.password ? (
            <Text color="red.500" fontSize="sm" mt={3}>
              {formik.errors.password}
            </Text>
          ) : null}
        </Box>

        <Button
          mt={8}
          isFullWidth
          colorScheme="light"
          bg="#00A2E8"
          isLoading={loading}
          type="submit"
        >
          Login
        </Button>
      </Box>
    </>
  );
};

export default LoginForm;
